"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountDataStore = exports.AccountStatus = void 0;
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var AngularSyncStore_1 = __importDefault(require("Utils/AngularSyncStore"));
var TeamDataStore_1 = require("./TeamDataStore");
var PendingUsersDataStore_1 = require("./PendingUsersDataStore");
var InviteService_1 = require("./InviteService");
var UsersDataStore_1 = require("DataStores/Account/UsersDataStore");
var Types_1 = require("@CommonFrontendBackend/Account/Types");
var AccountIntegrationsDataStore_1 = require("./AccountIntegrationsDataStore");
var CustomLinkPreviewAccountSettingsStore_1 = require("./CustomLinkPreviewAccountSettingsStore");
var Types_2 = require("./Types");
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["Closed"] = "closed";
    AccountStatus["Open"] = "";
})(AccountStatus || (exports.AccountStatus = AccountStatus = {}));
var AccountDataStore = (function (_super) {
    __extends(AccountDataStore, _super);
    function AccountDataStore(apiBaseUrl, user, userList, teamsService, accountApiService, accountService, angularSyncServices) {
        if (angularSyncServices === void 0) { angularSyncServices = { disableSync: true }; }
        var _this = _super.call(this, user.account, angularSyncServices, {
            extractDataFromAngular: extractDataFromAngular,
        }) || this;
        _this.accountApiService = accountApiService;
        _this.onAngularUpdated = function (angularAccount) {
            _this.account.name = angularAccount.name;
            _this.account.integrations = angularAccount.integrations;
            _this.account.authenticationSettings = angularAccount.authenticationSettings;
            _this.account.census = angularAccount.census;
            _this.account.status = angularAccount.status;
        };
        _this.planDisplayName = user.account.plan.displayName;
        _this.planInternalName = user.account.plan.internalName;
        _this.settings = user.account.settings;
        _this.analyticsSettings = _this.settings.analytics;
        var inviteService = new InviteService_1.InviteService(apiBaseUrl, user.account._id);
        _this.teamDataStore = new TeamDataStore_1.TeamDataStore(user.account._id, teamsService);
        _this.usersDataStore = new UsersDataStore_1.UsersDataStore(userList);
        _this.pendingUserDataStore = new PendingUsersDataStore_1.PendingUsersDataStore(inviteService, user.account);
        _this.integrationsDataStore = new AccountIntegrationsDataStore_1.AccountIntegrationsDataStore(_this.accountApiService);
        _this.customLinkPreviewStore = new CustomLinkPreviewAccountSettingsStore_1.CustomLinkPreviewAccountSettingsStore(user.account, accountService);
        _this.account = user.account;
        return _this;
    }
    AccountDataStore.prototype.getTeamDataStore = function () {
        return this.teamDataStore;
    };
    AccountDataStore.prototype.getUsersDataStore = function () {
        return this.usersDataStore;
    };
    AccountDataStore.prototype.getPendingUsersDataStore = function () {
        return this.pendingUserDataStore;
    };
    AccountDataStore.prototype.getIntegrationsDataStore = function () {
        return this.integrationsDataStore;
    };
    AccountDataStore.prototype.getCustomLinkPreviewStore = function () {
        return this.customLinkPreviewStore;
    };
    AccountDataStore.prototype.getAccountTimezone = function () {
        return this.account.settings.accountTimezone;
    };
    AccountDataStore.prototype.getAnalyticsSettings = function () {
        return this.analyticsSettings;
    };
    AccountDataStore.prototype.getPlanDisplayName = function () {
        return this.planDisplayName;
    };
    AccountDataStore.prototype.getPlanInternalName = function () {
        return this.planInternalName;
    };
    AccountDataStore.prototype.getUserInvitePermission = function () {
        return this.settings.permissions.userInvitePermission;
    };
    Object.defineProperty(AccountDataStore.prototype, "id", {
        get: function () {
            return this.account._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountDataStore.prototype, "name", {
        get: function () {
            return this.account.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountDataStore.prototype, "website", {
        get: function () {
            return this.account.website;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountDataStore.prototype, "phoneNumber", {
        get: function () {
            return this.account.phoneNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountDataStore.prototype, "authenticationSettings", {
        get: function () {
            return this.account.authenticationSettings;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountDataStore.prototype, "integrations", {
        get: function () {
            return this.account.integrations;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountDataStore.prototype, "census", {
        get: function () {
            return this.account.census;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountDataStore.prototype, "status", {
        get: function () {
            return this.account.status;
        },
        enumerable: false,
        configurable: true
    });
    AccountDataStore.prototype.setStatus = function (status) {
        this.account.status = status;
    };
    AccountDataStore.prototype.setTimezone = function (newTimezone) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.accountApiService.updateAccountTimezone(newTimezone)];
                    case 1:
                        _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            _this.account.settings.accountTimezone = newTimezone;
                        });
                        return [2];
                }
            });
        });
    };
    AccountDataStore.prototype.setAnalyticsAccountSettings = function (analyticsSettings) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.accountApiService.updateAccountAnalyticsSettings(analyticsSettings)];
                    case 1:
                        _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            _this.analyticsSettings = analyticsSettings;
                        });
                        return [2];
                }
            });
        });
    };
    AccountDataStore.prototype.setAuthenticationSettings = function (settings) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.accountApiService.updateAuthenticationSettings(settings)];
                    case 1:
                        _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            _this.account.authenticationSettings = settings;
                        });
                        return [2];
                }
            });
        });
    };
    AccountDataStore.prototype.update = function (args) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.accountApiService.update(args)];
                    case 1:
                        _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            if (args.name) {
                                _this.account.name = args.name;
                            }
                            if (args.website) {
                                _this.account.website = args.website;
                            }
                            if (args.phoneNumber) {
                                _this.account.phoneNumber = args.phoneNumber;
                            }
                        });
                        return [2];
                }
            });
        });
    };
    Object.defineProperty(AccountDataStore.prototype, "dataForAngular", {
        get: function () {
            return {
                name: this.name,
                authenticationSettings: this.authenticationSettings,
                integrations: this.integrations,
                census: this.census,
                status: this.status,
            };
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Object)
    ], AccountDataStore.prototype, "account", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], AccountDataStore.prototype, "name", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AccountDataStore.prototype, "website", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AccountDataStore.prototype, "phoneNumber", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_a = typeof Types_1.AuthenticationSettings !== "undefined" && Types_1.AuthenticationSettings) === "function" ? _a : Object),
        __metadata("design:paramtypes", [])
    ], AccountDataStore.prototype, "authenticationSettings", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object),
        __metadata("design:paramtypes", [])
    ], AccountDataStore.prototype, "integrations", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AccountDataStore.prototype, "census", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AccountDataStore.prototype, "status", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof Types_2.Status !== "undefined" && Types_2.Status) === "function" ? _c : Object]),
        __metadata("design:returntype", void 0)
    ], AccountDataStore.prototype, "setStatus", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof Types_1.Timezone !== "undefined" && Types_1.Timezone) === "function" ? _d : Object]),
        __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
    ], AccountDataStore.prototype, "setTimezone", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof Types_1.AnalyticsAccountSettings !== "undefined" && Types_1.AnalyticsAccountSettings) === "function" ? _f : Object]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], AccountDataStore.prototype, "setAnalyticsAccountSettings", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof Types_1.AuthenticationSettings !== "undefined" && Types_1.AuthenticationSettings) === "function" ? _h : Object]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], AccountDataStore.prototype, "setAuthenticationSettings", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
    ], AccountDataStore.prototype, "update", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccountDataStore.prototype, "onAngularUpdated", void 0);
    return AccountDataStore;
}(AngularSyncStore_1.default));
exports.AccountDataStore = AccountDataStore;
function extractDataFromAngular(account) {
    return (0, lodash_1.pick)(account, ["name", "authenticationSettings", "integrations", "census", "status"]);
}
